<template>
  <div>
    <!--<div v-if='spritesheetData.meta.image' class="p-2 grid grid-cols-4 md:grid-cols-8 gap-2">-->
    <div v-if='spritesheetData.meta.image' class="flex flex-wrap flex-row justify-start">
      <button v-for='(image,i) in images'
              class="flex flex-col justify-start bg-gray-200 shadow-sm rounded hover:border-gray-600 m-2"
             :class='checkSelected(image)'
              @click='onSelectImage(image)'
              :key='image.url + "-" + i'>
        <div class="object-contain mx-auto"
             loading="lazy"
             :style='image.style' />
      </button>
    </div>
  </div>
</template>
<script>
import { toPairs } from 'lodash';
export default {
  inject: ['api'],
  props:{
    spritesheet:{
      type: String,
      required: true
    }
  },
  data() {
    return {
      spritesheetData: {
        frames:{},
        meta:{}
      },
      selectedImage:{}
    }
  },
  methods:{
    checkSelected(image) {
      if (image.name === this.selectedImage.name) {
        return 'bg-blue-400 border-4 border-blue-700';
      } else {
        return 'border';
      }
    },
    onSelectImage(image) {
      this.selectedImage = image;
      this.$emit('select', {image,spritesheet:this.spritesheet});
    }
  },
  async mounted() {
    const url = this.api.makeSpritesheetUrlEditor(this.spritesheet);
    const response = await fetch(url);
    this.spritesheetData = await response.json();
  },
  computed:{
    image() {
      return this.api.makeSpritesheetUrlEditor(this.spritesheetData.meta.image);
    },
    images() {
      const url = this.image;
      return toPairs(this.spritesheetData.frames)
        .map( ([name, tilespec]) => {
          const left = tilespec.frame.x;
          const top = tilespec.frame.y;
          //const left = 0;
          //const top = 0;
          const width = tilespec.frame.w;
          const height = tilespec.frame.h;
          //const width = 64;
          //const height = 64;

          const style = {
            width: `${width}px`,
            height: `${height}px`,
            //background: `url(${url}) no-repeat`,
            //'background-position': `${left}px ${top}px`
            'background': `url(${url}) ${-left}px ${-top}px`
          };
          return {
            name,
            left,
            top,
            width,
            height,
            style
          }
        });
    }
  }
}
</script>
